import type { AnnouncementsState } from '../reducer/AnnouncementReducer';

export const announcementsList = (state: { announcements: AnnouncementsState }) => state.announcements.announcementList;

export const unReadAnnouncementCount = (state: { announcements: AnnouncementsState }) => state.announcements.announcementList.filter(announcement => !announcement.read).length ?? 0;
